var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 5981 2083",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1970.37,-7167.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7913.39,7511.77C7913.39,7342.31 7775.8,7204.72 7606.34,7204.72L2314.92,7204.72C2145.46,7204.72 2007.87,7342.31 2007.87,7511.77L2007.87,8905.55C2007.87,9075.01 2145.46,9212.6 2314.92,9212.6L7606.34,9212.6C7775.8,9212.6 7913.39,9075.01 7913.39,8905.55L7913.39,7511.77Z",
    style: {
      fill: "rgb(180,255,233)",
      stroke: "rgb(49,157,126)",
      strokeWidth: 75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2007.87,8503.94L7913.39,8486.76L7889.76,9023.62L7748.03,9165.35L7511.81,9212.6L2220.47,9212.6L2125.98,9165.35L2007.87,8976.38L2007.87,8503.94Z",
    style: {
      fill: "rgb(93,255,182)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7913.39,7511.77C7913.39,7342.31 7775.8,7204.72 7606.34,7204.72L2314.92,7204.72C2145.46,7204.72 2007.87,7342.31 2007.87,7511.77L2007.87,8905.55C2007.87,9075.01 2145.46,9212.6 2314.92,9212.6L7606.34,9212.6C7775.8,9212.6 7913.39,9075.01 7913.39,8905.55L7913.39,7511.77Z",
    style: {
      fill: "none",
      stroke: "rgb(49,157,126)",
      strokeWidth: 75
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118.11,-236.22)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3248.03,
    cy: 8444.88,
    r: 767.717,
    style: {
      fill: "white",
      stroke: "rgb(180,255,233)",
      strokeWidth: "333.33px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-118.11,-236.22)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3248.03,
    cy: 8444.88,
    r: 767.717,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "170.83px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.769231,0,0,0.769231,4351.91,1535.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3248.03,
    cy: 8444.88,
    r: 767.717,
    style: {
      fill: "white",
      stroke: "rgb(180,255,233)",
      strokeWidth: 325
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.769231,0,0,0.769231,4351.91,1535.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3248.03,
    cy: 8444.88,
    r: 767.717,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "162.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.769231,0,0,0.769231,2698.36,1535.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3248.03,
    cy: 8444.88,
    r: 767.717,
    style: {
      fill: "white",
      stroke: "rgb(180,255,233)",
      strokeWidth: "352.08px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,141.732,1.81899e-12)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "4771.65px",
    y: "9073.73px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 400
    }
  }, "BY")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1795.28,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "4771.65px",
    y: "9073.73px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 400
    }
  }, "NC")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.769231,0,0,0.769231,2698.36,1535.43)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3248.03,
    cy: 8444.88,
    r: 767.717,
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "162.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1393.7,-2649.96)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "1299.21px",
    y: "11059.4px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 600
    }
  }, "CC")), /*#__PURE__*/React.createElement("g", {
    id: "g353",
    transform: "matrix(46.4947,0,0,46.4906,-6084.7,365.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path355",
    d: "M245.69,162.009C245.69,161.593 245.352,161.255 244.936,161.255L240.164,161.255C239.748,161.255 239.41,161.593 239.41,162.009L239.41,166.782L240.741,166.782L240.741,172.434L244.358,172.434L244.358,166.782L245.69,166.782L245.69,162.009L245.69,162.009Z",
    style: {
      fillRule: "nonzero"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle357",
    cx: 242.55,
    cy: 158.995,
    r: 1.632
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,732.283,1589.12)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "5905.51px",
    y: "6678.6px",
    style: {
      fontFamily: "'Arial-BoldMT', 'Arial', sans-serif",
      fontWeight: 700,
      fontSize: 750
    }
  }, "$")), /*#__PURE__*/React.createElement("path", {
    d: "M6472.44,7653.54L7275.59,8409.45",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "116.67px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommons);
export default __webpack_public_path__ + "static/media/commons.f953104b2a1052519d0b530e6f5d5944.svg";
export { ForwardRef as ReactComponent };